
export type GetOrderInfo404 = {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
};
